import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertWarning18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.49251 2.12589L7.48448 2.1403L0.983311 14.1243C0.328469 15.2656 1.16951 16.76 2.49727 16.75L6.50003 16.75L6.50005 15.25L2.49402 15.2499L2.48651 15.25C2.27048 15.2522 2.21113 15.0067 2.29694 14.8485L8.79773 2.86521C8.88783 2.7152 9.10259 2.71528 9.19259 2.86535L15.7034 14.8489C15.7893 15.007 15.7291 15.2521 15.5136 15.25L11.5 15.25L11.5 16.75L15.5028 16.75C16.8307 16.76 17.6717 15.2653 17.0166 14.124L10.5055 2.13988L10.4977 2.12589C9.84336 0.980477 8.14688 0.980475 7.49251 2.12589Z'
      fill='currentColor'
    />
    <path d='M9.75004 6.5V13.5H8.25004V6.5H9.75004Z' fill='currentColor' />
    <path
      d='M9.00004 17C9.55232 17 10 16.5523 10 16C10 15.4477 9.55232 15 9.00004 15C8.44775 15 8.00004 15.4477 8.00004 16C8.00004 16.5523 8.44775 17 9.00004 17Z'
      fill='currentColor'
    />
  </Svg>
);

AlertWarning18.displayName = 'AlertWarning18';
export default AlertWarning18;
